"use strict";
/* eslint-disable */
/* eslint max-lines: 0 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class for handling firing events to GWA on the web.
 * Make sure you call loadAnalytics before attempting to fire any events.
 * @author Christopher Pole
 */
var WebAnalytics = /** @class */ (function () {
    /**
     * Initialize the class
     * @constructor
     * @param {Object} [options] Options for initalizing the class
     * @return {Void} nothing.
     */
    function WebAnalytics(options) {
        //  Ensure required settings are present
        if (!options || !options.analyticsScriptSrc) {
            throw new Error('Web analytics requires a script source setting');
        }
        //  Override default settings with options
        this.unsentEventQueue = [];
        this.analyticsScriptSrc = options.analyticsScriptSrc;
        this.gwaLoadCheckPollInterval = options.gwaLoadCheckPollInterval || 1000;
        /* eslint-disable no-console */
        this.logger = options.logger || {
            log: console.log,
            error: console.error,
        };
        /* eslint-enable no-console */
        this.getDefaultTrackingData = options.getDefaultTrackingData
            ? options.getDefaultTrackingData
            : function () { return ({
                gwa_account: 'rbiuk-icis-genesis-dev',
                gwa_server: 'website',
            }); };
        this.gwaAdded = false;
        this.gwaLoaded = false;
        //  Bind context of class methods
        this.loadAnalytics = this.loadAnalytics.bind(this);
        this._loadAnalytics = this._loadAnalytics.bind(this);
        this.onScriptLoaded = this.onScriptLoaded.bind(this);
        this.trackPageView = this.trackPageView.bind(this);
        this.trackAction = this.trackAction.bind(this);
        this.trackEvent = this.trackEvent.bind(this);
    }
    /**
     * Loads the analytics by injecting the script on the page
     * if it does not already exist
     * @return {Void} nothing.
     */
    WebAnalytics.prototype.loadAnalytics = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadAnalyticsPromise = this._loadAnalytics();
                        return [4 /*yield*/, this.loadAnalyticsPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Tracks an action
     * @param {Object} trackingDataOverrides Overrides for the tracking data
     * @return {Void} nothing.
     */
    WebAnalytics.prototype.trackAction = function (trackingDataOverrides) {
        if (trackingDataOverrides === void 0) { trackingDataOverrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    //  Apparently using gwa_trackInPageAction isn't working as intended.
                    //  We can switch this method back in the future if we like
                    return [4 /*yield*/, this.loadAnalyticsPromise];
                    case 1:
                        //  Apparently using gwa_trackInPageAction isn't working as intended.
                        //  We can switch this method back in the future if we like
                        _a.sent();
                        return [4 /*yield*/, this.trackEvent('gwa_trackPageView', trackingDataOverrides)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Tracks a page view event. Saves params for future actions
     * @param {Object} trackingDataOverrides Overrides for the tracking data for this page
     * view and subsequent actions
     * @return {Void} nothing.
     */
    WebAnalytics.prototype.trackPageView = function (trackingDataOverrides) {
        if (trackingDataOverrides === void 0) { trackingDataOverrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadAnalyticsPromise];
                    case 1:
                        _a.sent();
                        for (i = 1; i <= 4; i += 1) {
                            this.currentSiteSections["gwa_siteSection" + i] = trackingDataOverrides["gwa_siteSection" + i]
                                || this.currentSiteSections["gwa_siteSection" + i];
                        }
                        return [4 /*yield*/, this.trackEvent('gwa_trackPageView', trackingDataOverrides)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Formats and handles events and then sends to GWA if possible
     * @param {Function} trackingFunction The GWA method to call for sending the event
     * @param {Object} trackingDataOverrides Overrides for the tracking data
     * @return {Void} nothing.
     */
    WebAnalytics.prototype.trackEvent = function (trackingFunctionName, trackingDataOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var trackingData, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = [{}];
                        return [4 /*yield*/, this.getDefaultTrackingData()];
                    case 1:
                        trackingData = __assign.apply(void 0, _a.concat([_b.sent(),
                            this.currentSiteSections,
                            trackingDataOverrides]));
                        //  Work out the pagename field or use the override given
                        if (!trackingDataOverrides.gwa_pageName) {
                            trackingData.gwa_pageName = trackingData.gwa_siteSection1 + "|" + trackingData.gwa_siteSection2 + "|" + trackingData.gwa_siteSection3 + "|" + trackingData.gwa_siteSection4 + "|" + trackingData.gwa_contentTitle;
                        }
                        //  Copy the pagename field to the content hierarchy or use the override given
                        if (!trackingDataOverrides.gwa_contentHierarchy) {
                            trackingData.gwa_contentHierarchy = trackingData.gwa_pageName;
                        }
                        // Copy the page name to downloadPagename if tracking a file download
                        if (trackingDataOverrides.gwa_trackDownloadLink
                            && !trackingDataOverrides.gwa_downloadPagename) {
                            trackingData.gwa_downloadPagename = trackingData.gwa_pageName;
                        }
                        //  If GWA hasn't loaded then add event to the queue
                        if (!this.gwaLoaded) {
                            this.unsentEventQueue.push({
                                method: trackingFunctionName,
                                trackingData: trackingData,
                            });
                            this.logger.log('Adding unsent event to queue', trackingData);
                        }
                        else {
                            //  If GWA has loaded then send the event
                            this.sendToGWA(trackingFunctionName, trackingData);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    WebAnalytics.prototype._loadAnalytics = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, gwa_account, gwa_siteSection1, gwa_siteSection2, gwa_siteSection3, gwa_siteSection4, gwa_server, scriptTag;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.gwaAdded) return [3 /*break*/, 2];
                        this.logger.log('Loading analytics...');
                        return [4 /*yield*/, this.getDefaultTrackingData()];
                    case 1:
                        _a = _b.sent(), gwa_account = _a.gwa_account, gwa_siteSection1 = _a.gwa_siteSection1, gwa_siteSection2 = _a.gwa_siteSection2, gwa_siteSection3 = _a.gwa_siteSection3, gwa_siteSection4 = _a.gwa_siteSection4, gwa_server = _a.gwa_server;
                        //  Set up the current site section tracking based on the default tracking data
                        this.currentSiteSections = {
                            gwa_siteSection1: gwa_siteSection1,
                            gwa_siteSection2: gwa_siteSection2,
                            gwa_siteSection3: gwa_siteSection3,
                            gwa_siteSection4: gwa_siteSection4,
                        };
                        //  Add the meta tags for the initial event to the page
                        document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', "\n          <meta name=\"gwa_Account\" content=\"" + gwa_account + "\">\n          <meta name=\"gwa_siteSection1\" content=\"" + gwa_siteSection1 + "\">\n          <meta name=\"gwa_siteSection2\" content=\"" + gwa_siteSection2 + "\">\n          <meta name=\"gwa_siteSection3\" content=\"" + gwa_siteSection3 + "\">\n          <meta name=\"gwa_contentTitle\" content=\"analytics script load\">\n          <meta name=\"gwa_server\" content=\"" + gwa_server + "\">\n          <meta name=\"gwa_pageName\" content=\"" + gwa_siteSection1 + "|" + gwa_siteSection2 + "|" + gwa_siteSection3 + "|analytics script load\">\n          <meta name=\"gwa_contentHierarchy\" content=\"" + gwa_siteSection1 + "|" + gwa_siteSection2 + "|" + gwa_siteSection3 + "|analytics script load\">\n        ");
                        scriptTag = document.createElement('script');
                        scriptTag.src = this.analyticsScriptSrc;
                        scriptTag.onload = this.onScriptLoaded;
                        document.getElementsByTagName('body')[0].appendChild(scriptTag);
                        this.gwaAdded = true;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Callback for when the analytics script has loaded.
     * GWA isn't immediately available, so we have to keep polling until the
     * methods are not undefined
     * @return {Void} nothing.
     */
    WebAnalytics.prototype.onScriptLoaded = function () {
        //  When GWA is available, send any events in the queue
        if (typeof window._satellite !== 'undefined' && window.gwa_resetSiteCatalystEvents) {
            this.gwaLoaded = true;
            this.logger.log('Analytics loaded!');
            if (this.unsentEventQueue.length) {
                this.sendUnsentEventQueue();
            }
        }
        else {
            //  If GWA isn't available then check again after a short interval
            window.setTimeout(this.onScriptLoaded, this.gwaLoadCheckPollInterval);
        }
    };
    /**
     * Sends given tracking data to GWA
     * @param {Function} trackingFunction The method to call for sending the tracking event
     * @param {Object} trackingData Data to send to GWA
     * @return {Void} nothing.
     */
    WebAnalytics.prototype.sendToGWA = function (trackingFunctionName, trackingData) {
        try {
            window.gwa_resetSiteCatalystEvents();
            //  Populate the meta values with the tracking data
            Object.getOwnPropertyNames(trackingData).forEach(function (fieldName) {
                window.gwa_SetMetaValue(fieldName, trackingData[fieldName]);
            });
            //  Send event to GWA
            window[trackingFunctionName](trackingData.gwa_contentHierarchy);
            //  Unset all of the meta values
            Object.getOwnPropertyNames(trackingData).forEach(function (fieldName) {
                window.gwa_SetMetaValue(fieldName, '');
            });
            window.gwa_resetSiteCatalystEvents();
            this.logger.log("Sent tracking event (" + trackingFunctionName + ")", trackingData);
        }
        catch (err) {
            this.logger.error('Error tracking analytics event!', err);
        }
    };
    /**
     * Sends all unsent events in the unsent event queue
     * @return {Void} nothing.
     */
    WebAnalytics.prototype.sendUnsentEventQueue = function () {
        var _this = this;
        this.logger.log('Sending unsent analytics events...');
        this.unsentEventQueue.forEach(function (unsentEvent) {
            _this.sendToGWA(unsentEvent.method, unsentEvent.trackingData);
        });
        this.logger.log('Unsent analytics events sent!');
    };
    return WebAnalytics;
}());
exports.default = WebAnalytics;
//# sourceMappingURL=WebAnalytics.js.map